<template>
  <!-- Don't drop "q-app" class -->
  <div id="q-app">
    <router-view :root="$parent.$data" :parent="$parent" />
  </div>
</template>

<script>
/*
 * Root component
 */
export default {
  created() {
    // if (window.device && window.device.platform !== "browser") {
    //   window.FirebasePlugin.hasPermission((hasPermission) => {
    //     if (hasPermission) {
    //       this.initFirebasePlugin();
    //     } else {
    //       window.FirebasePlugin.grantPermission((permissionGranted) => {
    //         if (permissionGranted) this.initFirebasePlugin();
    //       });
    //     }
    //   });
    // }
  },
  methods: {
    // initFirebasePlugin() {
    //   window.FirebasePlugin.onTokenRefresh(
    //     (fcmToken) => {
    //     },
    //     (err) => alert(`Error getting token ${err}`)
    //   );
    //   window.FirebasePlugin.onMessageReceived(
    //     (message) => {        },
    //     () => {}
    //   );
    // }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/App.vue